import DealerCard from "../components/DealerCard";

export default function Dealers() {
  return (
    <>
      <nav className="breadcrumbs">Accueil / Revendeurs</nav>
      <h1>Revendeurs</h1>
      <div className="grid" style={{ marginTop: 12 }}>
        <DealerCard
          name="1001Coffres"
          location="94340 Cachan"
          website="https://1001coffres.com"
        />
      </div>
      <p className="color-product-desc" style={{ marginTop: 12 }}>
        Vous souhaitez devenir revendeur ? <a href="/contact">Contactez-nous</a>
        .
      </p>
    </>
  );
}
